import { styled } from 'styles';

export const Content = styled.div`
  padding-top: 50px;

  h1 {
    font-weight: 600;
    font-size: 2.4em;
  }
`;
